import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const Pagamento = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { plan } = (location.state || {}) as { plan?: string };

  const [loading, setLoading] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('pix');

  const [userData, setUserData] = useState(() => {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  });

  const userName = userData?.fullName || 'Visitante';

  useEffect(() => {
    if (!plan) {
      toast.error('Por favor, selecione um plano antes de continuar.');
      navigate('/signup');
    }
  }, [plan, navigate]);

  useEffect(() => {
    const handleStorageChange = () => {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        setUserData(JSON.parse(storedUser));
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const handlePayment = () => {
    setLoading(true);
    setTimeout(() => {
      if (userData) {
        const updatedUser = { ...userData, isSubscribed: true };
        localStorage.setItem('user', JSON.stringify(updatedUser));
        localStorage.setItem('has-plan', 'true');
        setUserData(updatedUser);
        window.dispatchEvent(new Event('storage'));
      }

      toast.success('Assinatura confirmada com sucesso!');
      navigate('/home');
    }, 2000);
  };

  const planos = {
    basic: { name: 'Básico', price: 'R$ 9,90' },
    silver: { name: 'Silver', price: 'R$ 19,90' },
    premium: { name: 'Premium Família', price: 'R$ 29,90' },
  };

  if (!plan) return null;

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black text-white p-6 relative">
      <style>{`
        @media (max-width: 768px) {
          #bgVideo {
            display: none !important;
          }
        }
      `}</style>

      <video id="bgVideo" autoPlay muted loop playsInline className="absolute top-0 left-0 w-full h-full object-cover opacity-50 z-[-1]">
        <source src="/videos/intro.mp4" type="video/mp4" />
      </video>

      <img src="/logo.png" alt="Logo RusticoPlay" className="h-[80px] mb-6" />
      <h1 className="text-2xl font-bold mb-2">Confirmação de Assinatura</h1>
      <p className="mb-4">Olá, <strong>{userName}</strong>! Você selecionou o plano:</p>

      <div className="bg-white/10 border border-rustico-brown p-4 rounded-md text-center mb-6">
        <h2 className="text-xl font-semibold mb-1">{planos[plan]?.name}</h2>
        <p className="text-lg">{planos[plan]?.price} <span className="text-sm text-gray-400">/ mês</span></p>
      </div>

      <div className="w-full max-w-[400px]">
        <button
          onClick={handlePayment}
          disabled={loading}
          className="w-full bg-rustico-brown hover:bg-[#6f5f3f] text-white font-bold py-3 px-6 rounded-md transition-colors duration-300 disabled:opacity-60"
        >
          {loading ? 'Processando...' : 'Confirmar Pagamento'}
        </button>
      </div>

      <button
        onClick={() => navigate('/signup')}
        className="mt-4 text-sm text-gray-400 hover:underline"
      >
        Escolher outro plano
      </button>
    </div>
  );
};

export default Pagamento;
